__turbopack_context__.v({
  "className": "bricolage_grotesque_8e8303a4-module__vxAGDa__className",
});
